<template>
    <div class="card card-body">
        <h3 class="h5">Selecteer een champagnehuis</h3>
        <label for="maison"> Selecteer een champagnehuis </label>
        <v-select
            id="maison"
            @search="fetchOptions"
            :options="maisonOptions"
            :reduce="(maison) => maison.value"
            v-model="selectedMaisonId"
        />
    </div>

    <template v-if="maison">
        <div class="card">
            <div class="card-header">
                <h5 class="card-title mb-0">Bulk tijdsloten toevoegen</h5>
            </div>
            <div class="card-body">
                <BulkCreator
                    :maison="maison"
                    :activities="maison.activities"
                    @on-update="fetchMaison"
                />
            </div>
        </div>

        <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">Tijdsloten beheren</h5>

                <div>
                    <AgendaModal
                        :activities="maison.activities"
                        @on-update="fetchMaison"
                    />
                </div>
            </div>
            <div>
                <MaisonAgendas
                    :maison="maison"
                    :activities="maison.activities"
                    @on-update="fetchMaison"
                />
            </div>
        </div>
    </template>
</template>

<script>
export default {
    data() {
        return {
            maisons: [],
            selectedMaisonId: null,
            maison: null,
        };
    },
    mounted() {},
    methods: {
        async fetchOptions(search, loading) {
            if (search.length > 2) {
                const {
                    data: { data: maisons },
                } = await axios.get(
                    `/admin/api/maisons?term=${search}&_type=query&q=${search}`
                );

                this.maisons = maisons;
            }
        },
        async fetchMaison() {
            const {
                data: { data: maison },
            } = await axios.get(`/admin/api/maisons/${this.selectedMaisonId}`);

            this.maison = maison;
        },
    },
    computed: {
        maisonOptions() {
            return this.maisons.map((maison) => ({
                value: maison.id,
                label: maison.name,
            }));
        },
    },
    watch: {
        async selectedMaisonId() {
            await this.fetchMaison();
        },
    },
};
</script>
